module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69719/img/podcast-zero.png"